import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button, Container } from 'semantic-ui-react';
import * as yup from 'yup';
import moment from 'moment';
import AddTitleBar from '../../../titleBar/add_titleBar';
import LoadingPlaceholder from '../../../placeholderComponent/loadingPlaceholder';
import { Checkbox } from 'formik-semantic-ui';
import Axios from 'axios';
import APP_CONSTANTS from '../../../../config/constants';

import SupportingDoc from './supportingDoc';

import { store } from '../../../../redux/store/store';

//Inputs
import { DateData } from '../../../formikInput/date';
import FileUpload from '../../../formikInput/uploadFile';

//Add-Product
import AddProduct from '../../../purchaseOrder/addProduct';
import ActivePurchaseOrder from './activePurchaseOrder'

//Dropdowns
import PurchaseOrderVendorDropdown from '../../../dropdowns/purchaseOrderVendorDropdown';
import PurchaseOrderBranchDropdown from '../../../dropdowns/purchaseOrderBranchDropdown';
import BranchDropdown from '../../../dropdowns/branchDropdown';
import VehicleDropdown from '../../../dropdowns/vehicleDropdown';

//Actions 
import { createBill } from '../../../../redux/actions/billActions';
import { getVendorPurchaseOrder, updatePurchaseOrder } from '../../../../redux/actions/purchaseOrderActions';
import { getBills } from '../../../../redux/actions/billActions';
import ReadAxios from '../../../axiosComponent/read';


const ViewBill = (props) => {

    const { createBill, getVendorPurchaseOrder, getBills, billData, vendorPurchaseOrderData, purchaseOrderLoading, updatePurchaseOrder } = props;

    //State
    const [activateManualPO, setActivateManualPO] = useState(false);
    const [initialize, setInitialize] = useState(false)
    const [vehicleData, setVehicleData] = useState([]);
    const [vendorName, setVendorName] = useState(localStorage.getItem("vendorCode"));
    const [vendorDetails, setVendorDetails] = useState([])
    const [VendorState, setVendorState] = useState('');
    const [vendorStateId, setVendorStateId] = useState('');
    const [branchCode, setBranchCode] = useState('');
    const [masterState, setMasterState] = useState('');
    const [vendorBranchData, setVendorBranchData] = useState([])
    const [stateData, setStateData] = useState([]);
    const [gst, setGst] = useState([]);
    const [supportDocArray, setSupportDocArray] = useState([]);

    const [orderLoading, setOrderLoading] = useState(false);

    const [orderDetails, setorderDetails] = useState([])

    const [currentPageNoProp, setCurrentPageNoProp] = useState(1);
    const [totalPagesPresentProp, setTotalPagesPresentProp] = useState(1);

    const [searchText, setSearchText] = useState('');

    const getVehicleData = childData => {
        setVehicleData(childData)
    }

    //ArrayHelper	
    Array.prototype.sum = function (prop) {
        var total = 0
        for (var i = 0, _len = this.length; i < _len; i++) {
            total += this[i][prop]
        }
        return total
    }


    //UseEffect
    useEffect(() => {

        const id = props.location.state.billId

        setInitialize(true)
        setOrderLoading(true)
        getBills(id)
        getData()

        let token = localStorage.getItem('isloggedIn')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')

        let supportBillData = JSON.stringify
            ({
                "customerNumber": customerNo,
                "userId": userId,
                "customer_no": customerNo,
                "user_id": userId,
                "customerNo": customerNo,
                "billId": id.toString()
            })


        Axios.post(`${APP_CONSTANTS.BASE_URL}purchase/bill/getBillSupportingDocumentType`, supportBillData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setSupportDocArray(response.data.data);
        }))
            .catch(error => console.log(error));
    }, [])

    let getData = () => {

        const vendorData = {
            vendorCode: vendorName,
            billId: props.location.state.billId
        }

        const edit = true

        getVendorPurchaseOrder(vendorData, 1, "", edit)


        setTimeout(() => {
            let getPurchaseOrderPageState = store.getState().getPurchaseOrderReducer.purchaseOrder.pagination;
            setTotalPagesPresentProp(getPurchaseOrderPageState.totalPages)
            console.log("+==================getData====================+")
            console.log(getPurchaseOrderPageState.totalPages)
            formatPODetails(vendorPurchaseOrderData).then(() => { setInitialize(false); setOrderLoading(false); })

        }, 3000);

        let token = localStorage.getItem('isloggedIn')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')

        let vendorId = localStorage.getItem('vendorId')

        Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vendorDetails/${vendorId}?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        })
            .then((response => {
                setVendorBranchData(response.data.resultSet.branches)
                setVendorDetails(response.data.resultSet)

            }))
            .catch((error => {
                console.log(error)

            }))

        Axios.get(`${APP_CONSTANTS.BASE_URL}/masters/stateMaster?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setStateData(response.data.resultSet)
        }))
            .catch(error => console.log(error))

    }
    let formatPODetails = async (data) => {
        let arr = []
        if (data != null && data != undefined) {
            for (const [index, o] of data.entries()) {
                const response = await ReadAxios({
                    completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/billing/${o.poId}`,
                })
                // if (response.data.data != null) {
                let temp = {}
                temp.poId = o.poId
                temp.poReferenceNo = o.poReferenceNo
                temp.order_date = response.data?.data?.order_date ? response.data.data?.order_date : 'N/A'
                temp.order_reference_no = response.data?.data?.order_reference_no ? response.data.data.order_reference_no : 'N/A'
                temp.lr_no = response.data?.data?.deliveries?.[0]?.lr_number ? response.data.data.deliveries[0].lr_number : 'N/A'
                temp.vendor_lr_no = response?.data?.data?.vendor_lr_numbers ? response.data.data.vendor_lr_numbers && response.data.data.vendor_lr_numbers.join(", ") : 'N/A'
                temp.delivery_status = response.data?.data?.deliveries?.[0]?.delivery_status ? response.data.data.deliveries[0].delivery_status : 'N/A'
                temp.checkbox = false
                temp.vendorCode = o.vendorId
                temp.branchCode = o.branchId
                temp.vehicleNo = o.vehicleId
                temp.poQuantity = o.poQuantity
                temp.poAmount = o.poAmount
                temp.poNumber = o.poNumber
                temp.deliveryDate = o.deliveryDate ? o.deliveryDate : ''
                temp.sgstAmount = o.sgstAmount
                temp.cgstAmount = o.cgstAmount
                temp.igstAmount = o.igstAmount
                temp.adjustment = o.adjustment
                temp.totalOrderAmt = o.totalOrderAmt
                temp.remarks = o.remarks
                temp.gstTaxType = o.gstTaxType
                temp.poDate = o.poDate
                temp.tdsAmount = o.tdsAmount
                temp.taxableAmount = o.taxableAmount
                temp.totalDiscount = o.totalDiscount
                temp.remarksList = []

                if (response?.data?.data?.deliveries && response?.data?.data?.deliveries?.length > 0) {
                    response.data.data.deliveries.forEach(element => {
                        if (element?.remarks)
                            temp.remarksList.push(element.remarks)
                    });
                }
                arr[index] = temp
            }
        }

        setorderDetails(arr)

    }

    let handleOrderRefresh = (data) => {
        console.log("handleOrderRefresh", data)
        if (data) {
            setInitialize(true)
            setOrderLoading(true)
            getData()
        }
    }

    let handlePageRefresh = (pageNo) => {
        console.log("handlePageRefresh", pageNo)
        if (pageNo) {
            setInitialize(true)
            setOrderLoading(true)
            getDataWithPageChange()
        }
    }

    let handlePaginationChange = (pageNo) => {
        const vendorData = {
            vendorCode: vendorName,
            billId: props.location.state.billId
        }
        setCurrentPageNoProp(pageNo)
        if (searchText?.length > 0)
            getVendorPurchaseOrder(vendorData, pageNo, searchText, true)
        else
            getVendorPurchaseOrder(vendorData, pageNo, '', true)
        setOrderLoading(true)
        setTimeout(() => {
            handlePageRefresh(pageNo)
        }, 3000);

    }

    let handleSearchString = (searchString) => {
        const vendorData = {
            vendorCode: vendorName,
            billId: props.location.state.billId
        }
        setSearchText(searchString)
        setCurrentPageNoProp(1)
        getVendorPurchaseOrder(vendorData, 1, searchString, true)
        setOrderLoading(true)
        setTimeout(() => {
            handlePageRefresh(1)
        }, 3000);
    }

    let getDataWithPageChange = () => {

        const vendorData = {
            vendorCode: vendorName,
            billId: props.location.state.billId
        }

        setTimeout(() => {
            let getPurchaseOrderPageState = store.getState().getPurchaseOrderReducer.purchaseOrder.pagination;
            setTotalPagesPresentProp(getPurchaseOrderPageState.totalPages)
            formatPODetails(vendorPurchaseOrderData).then(() => { setInitialize(false); setOrderLoading(false); })

        }, 3000);

        let token = localStorage.getItem('isloggedIn')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')

        let vendorId = localStorage.getItem('vendorId')

        Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vendorDetails/${vendorId}?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        })
            .then((response => {
                setVendorBranchData(response.data.resultSet.branches)
                setVendorDetails(response.data.resultSet)

            }))
            .catch((error => {
                console.log(error)

            }))

        Axios.get(`${APP_CONSTANTS.BASE_URL}/masters/stateMaster?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setStateData(response.data.resultSet)
        }))
            .catch(error => console.log(error))

    }
    // return data.forEach(async (element, index) => {
    //     let resp = await ReadAxios({
    //         completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/billing/${element.poId}`,
    //     })

    //     if (resp.data.data != null) {
    //         return resp.data.data
    //     }


    // })
    // return data.map(async (object, idx) => {
    //     console.log('>>', response.data.message)

    // })
    // element.poId

    // console.log('Bill Fetch', response)
    // if (response) {
    //     console.log(response.data.data)
    // }
    // .then((res) => {
    //     console.log('orderDetails', res.data.data)
    //     // if (res.data.data) {
    //     //     temp.order_date = res.data.data.order_date
    //     //     temp.order_reference_no = res.data.data.order_reference_no
    //     //     temp.lr_no = res.data.data.deliveries[0].lr_number
    //     //     temp.delivery_status = res.data.data.deliveries[0].delivery_status
    //     // }
    // })

    //Existing PO Array

    let activePOData = [];

    let tempDocArray = [];
    supportDocArray && supportDocArray.map((doc, docIndex) => {
        let temp = {};
        temp.billId = doc.billId
        temp.supportingDocumentTypeName = doc.supportingDocumentTypeName
        temp.supportingDocumentTypeId = doc.supportingDocumentTypeId
        temp.fileUrl = ""
        temp.fileDownload = doc.fileUrl
        temp.isDeleted = doc.isDeleted
        temp.billSupportingDocumentTypeMappingId = doc.billSupportingDocumentTypeMappingId

        return tempDocArray[docIndex] = temp
    })


    //Formik
    const initialValues = {
        vendorName: vendorName,
        billNumber: billData ? billData[0].billNo : "",
        billDate: billData ? billData[0].billDate : "",
        expectedPaymentDate: billData ? billData[0].expectedPaymentDate : "",
        billReceiptDate: billData ? billData[0].billReceiptDate : "",
        branch: billData ? billData[0].branchCode : "",
        vendorBranch: billData ? billData[0].vendorBranchCode : '',
        poReferenceNo: '',
        vehicleNo: '',
        billReferenceNo: billData ? billData[0].billReferenceNo : "",
        activePoAddedTotal: '',
        isGstApplicable: false,
        manualPoAddedTotal: '',
        productDetails: [{
            productName: '',
            startDate: '',
            endDate: '',
            hsnCode: '',
            sacCode: '',
            quantity: 1,
            rate: '',
            discount: '',
            discountType: "1",
            isAdditionalCharge: '',
            iGstPercent: 0,
            iGst: 0,
            cGstPercent: 0,
            cGst: 0,
            sGstPercent: 0,
            sGst: 0,
            amount: 0,
        }],
        supportDoc: tempDocArray || [{
            supportingDocumentTypeId: "0",
            supportingDocumentTypeName: "",
            fileUrl: "",
            billId: "0"
        }],
        activePODetails: orderDetails,
        fileUpload: '',
        finalAmount: '',
        activePOSelected: [],
    }

    const validateSchema = yup.object().shape({
        vendorName: yup.mixed().required('Partner Name is Required'),
        billDate: yup.mixed().required('Bill Date is Required'),
        branch: yup.mixed().required('Branch is Required'),
        expectedPaymentDate: yup.mixed().required('Expected Payment Date is Required'),
        billReferenceNo: yup.mixed().required('Bill Reference Number is Required'),
    })

    const onSubmit = (values, onSubmitProps) => {
        console.log("Product Onsubmit", values)

        const customerNumber = localStorage.getItem('customerNumber');
        const userId = localStorage.getItem('userId');
        console.log("here in 3");

        let psLineItems = [];
        values.productDetails.map((product, index) => {
            let temp = {}
            temp.psCode = product.productCode
            temp.psName = product.productName
            temp.startDate = product.startDate
            temp.endDate = product.endDate
            temp.psQty = product.quantity
            temp.psPrice = product.rate
            temp.psAmount = product.rate * product.quantity
            temp.igstPercent = product.iGstPercent
            temp.igstAmount = product.iGst
            temp.cgstPercent = product.cGstPercent
            temp.cgstAmount = product.cGst
            temp.sgstPercent = product.sGstPercent
            temp.sgstAmount = product.sGst
            temp.tdsCode = 9
            temp.discount = product.discount
            temp.finalDiscount = product.discount
            temp.discountType = product.discountType
            temp.taxableAmount = product.rate * product.quantity - product.discount
            psLineItems[index] = temp
        });

        let exLineItems = [];
        values.activePOSelected.map((product, index) => {
            let temp = {}
            temp.poReferenceNo = product.poReferenceNo
            exLineItems[index] = temp
        })

        console.log("here in 2");

        let manualPoArray = [
            {
                poReferenceNo: "",
                vendorCode: values.vendorName,
                branchCode: values.vendorBranch,
                vehicleNo: "",
                poQuantity: psLineItems.length,
                poAmount: values.finalAmount,
                sgstAmount: psLineItems.sum('sgstAmount'),
                cgstAmount: psLineItems.sum('cgstAmount'),
                igstAmount: psLineItems.sum('igstAmount'),
                adjustment: 0,
                totalOrderAmt: values.finalAmount,
                remarks: '',
                gstTaxType: 0,
                poDate: new Date(),
                tdsAmount: 0,
                taxableAmount: psLineItems.sum('taxableAmount'),
                totalDiscount: psLineItems.sum('discount'),
                psDetails: psLineItems
            }
        ]

        console.log("here in 1");


        if (values.poQuantity === 0) {
            console.log("here in 0");
            manualPoArray = []
        }
        console.log("here in 00");


        // if (activateManualPO) {
        //     exLineItems = [];
        // } else {
        //     manualPoArray = [];
        // }

        const createBillData = {
            customerNo: customerNumber,
            userId: userId,
            billReferenceNo: '',
            vendorCode: vendorName,
            billAmount: values.finalAmount,
            statusCode: '',
            fileUpload: values.fileUpload ? values.fileUpload.base64.split(',')[1] : '',
            isGstApplicable: values.isGstApplicable ? "1" : "0",
            expectedPaymentDate: moment(values.expectedPaymentDate).format("DD-MM-YYYY"),
            billReferenceNo: values.billReferenceNo,
            billDate: moment(values.billDate).format("DD-MM-YYYY"),
            totalPoAmount: values.finalAmount,
            termsConditions: '',
            remarks: '',
            branchCode: values.branch,
            vendorBranchCode: values.vendorBranch,
            gstTaxType: 2,
            totalTaxableAmount: 0,
            totalSgstAmount: manualPoArray ? manualPoArray.sgstAmount : '',
            totalCgstAmount: manualPoArray ? manualPoArray.cgstAmount : '',
            totalIgstAmount: manualPoArray ? manualPoArray.igstAmount : '',
            totalTdsAmount: 0,
            departMentCategoryCode: 0,
            irn: '',
            hsnCode: '',
            noOfLineItems: psLineItems.length,
            isPartialBill: 0,
            grn: '',
            grnDateTime: '',
            billReceiptDate: '',
            poDate: '',
            totalOrderAmt: values.finalAmount,
            adjustment: 0,
            poAmount: values.amount,
            poQuantity: 1,
            tdsAmount: 0,
            taxableAmount: 2,
            totalDiscount: 0,
            existingPoArray: exLineItems,
            manualPoArray: [],
        };

        console.log("Create Bill Request", createBillData)

        createBill(createBillData).then(() => {
            setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
        });
        console.log("Bill created")

    };

    const getBranchSelected = childData => {
        const branchDetails = vendorDetails.branches.find(data => data.vendorBranchCode === childData);
        const stateDetails = stateData.find(data => data.stateId === branchDetails.vendorBranchStateId);
        console.log("Branch Value", childData, branchDetails, stateDetails)


        console.log("branch Details", branchDetails)

        //Set GST and VendorState from Branch Selected
        setGst(branchDetails.vendorBranchGST);
        setVendorState(stateDetails.state);
        setVendorStateId(stateDetails.stateId)
        setBranchCode(branchDetails.vendorBranchCode);
    };

    const getMasterBranchSelected = (branchCode, branchData) => {
        const addedMasterBranchObject = branchData.find(data => data.branchCode === branchCode)
        setMasterState(addedMasterBranchObject.stateId)
        console.log("Branch Data", branchCode, branchData, addedMasterBranchObject)
    }

    const handleDownload = () => {
        window.open(billData[0].filePath)
    }

    let vendorLabel = {}
    const customerNo = localStorage.getItem('customerNumber')

    if (customerNo != 1158) {
        vendorLabel.vendorName = "Vendor Name"
        vendorLabel.vendorBranch = "Vendor Branch"
    } else {
        vendorLabel.vendorName = "Partner Name"
        vendorLabel.vendorBranch = "Partner Branch"
    }


    // console.log('LR INFO', )
    return (
        <React.Fragment>
            <AddTitleBar title="New Bill" LinkName="/bill" />
            <div className="m-2">
                <Formik
                    enableReinitialize={initialize}
                    initialValues={initialValues}
                    validationSchema={validateSchema}
                    onSubmit={onSubmit}>
                    {({ touched, errors, values, isSubmitting, setFieldValue, handleSubmit }) => (
                        <>
                            <Segment>
                                <div className="ui form">
                                    <FormUi.Group >
                                        <FormUi.Field width="4">
                                            <label className="labelName mt-2">{vendorLabel.vendorName}</label>
                                        </FormUi.Field>
                                        {console.log('VALUES', values, masterState, vendorStateId)}
                                        <FormUi.Field width="3">
                                            <Fieldmik component={PurchaseOrderVendorDropdown} name="vendorName" placeholder="Partner Name" getVendorPurchaseOrder={getVendorPurchaseOrder} value={vendorName} getVehicleData={getVehicleData} setInitialize={setInitialize} disabled />
                                            {touched.vendorName && errors.vendorName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorName}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">{vendorLabel.vendorBranch}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <Fieldmik disabled component={PurchaseOrderBranchDropdown} name="vendorBranch" getBranchSelected={getBranchSelected} branchData={vendorBranchData} value={values.vendorBranch} />
                                            {touched.vendorBranch && errors.vendorBranch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorBranch}</strong> : ''}
                                        </FormUi.Field>

                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width="4">
                                            <label className="labelName mt-2">Bill Date</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <DateData
                                                readOnly
                                                name={`billDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Date"
                                                selected={values.billDate}
                                                timeIntervals={5}
                                                customInput={<FormUi.Input error={values.billDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.billDate && errors.billDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.billDate}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Branch</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <Fieldmik disabled component={BranchDropdown} name="branch" placeholder="Branch" getMasterBranchSelected={getMasterBranchSelected} value={values.branch} />
                                            {touched.branch && errors.branch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.branch}</strong> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group >
                                        <FormUi.Field width="4">
                                            <label className="labelName mt-2">Bill Number</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <Fieldmik readOnly name="billNumber" placeholder="Bill Number" value={values.billNumber} />
                                            {touched.billNumber && errors.billNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.billNumber}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Expected Payment Date</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <DateData
                                                readOnly
                                                name={`expectedPaymentDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Date"
                                                selected={values.expectedPaymentDate}
                                                minDate={values.billDate}
                                                timeIntervals={5}
                                                customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.expectedPaymentDate && errors.expectedPaymentDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.expectedPaymentDate}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />

                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width="4">
                                            <label className="labelName mt-2">Bill Reference Number</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <Fieldmik readOnly name="billReferenceNo" placeholder="Reference Number" />
                                            {touched.billReferenceNo && errors.billReferenceNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.billReferenceNo}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />

                                        {billData && billData[0].filePath ?
                                            <>
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">Download Invoice</label>
                                                </FormUi.Field>
                                                <FormUi.Field>
                                                    <Button onClick={handleDownload} type="button" color="blue" icon='download' size="small" basic></Button>

                                                </FormUi.Field>
                                            </>
                                            :
                                            ""}

                                        {/* <FormUi.Field width="3">
                                            <label className="labelName mt-2">Upload Invoice</label>
                                        </FormUi.Field>

                                        <FormUi.Field width="1">
                                            <Fieldmik component={FileUpload} name="fileUpload" size="medium" typer={[".pdf"]} value={values.fileUpload} buttonName={values.fileUpload ? "Selected" : "Select"} />
                                            {touched.fileUpload && errors.fileUpload ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.fileUpload}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="3" /> */}

                                    </FormUi.Group>
                                    {/* <FormUi.Group>
                                        <FormUi.Field width="4">
                                            <label className="labelName mt-2">Is GST Applicable?</label>
                                        </FormUi.Field>
                                        <FormUi.Field>
                                            <Checkbox
                                                name={`isGstApplicable`}
                                                value={values.isGstApplicable}
                                            // inputProps={{disabled: viewmode}}
                                            />
                                        </FormUi.Field>
                                    </FormUi.Group> */}

                                </div>
                            </Segment>

                            <Segment compact>
                                <SupportingDoc viewMode={true} />
                            </Segment>


                            {
                                orderLoading ?

                                    <React.Fragment>
                                        <LoadingPlaceholder />
                                    </React.Fragment>
                                    :
                                    <Segment>
                                        <div className="ui form">
                                            <Button
                                                type="button"
                                                onClick={() => { setActivateManualPO(false); setInitialize(false) }}
                                                style={{ borderRadius: "5px 5px 0px 0px" }}
                                                size="small"
                                                toggle
                                                active={!activateManualPO}
                                            >
                                                Active Orders
                                            </Button>
                                            {/* <Button
                                                type="button"
                                                onClick={() => { setActivateManualPO(true); setInitialize(false) }}
                                                style={{ borderRadius: "5px 5px 0px 0px" }}
                                                size="small"
                                                toggle
                                                active={activateManualPO}
                                            >
                                                Additional Charges
                                            </Button> */}
                                            {/* FieldArray Component */}
                                            {activateManualPO ?
                                                <>
                                                    {/* <Container className="m-2">
                                                        <FormUi.Group >
                                                            <FormUi.Field width="3">
                                                                <label className="labelName mt-2">Vehicle Number</label>
                                                            </FormUi.Field>
                                                            <FormUi.Field width="3">
                                                                <Fieldmik component={VehicleDropdown} name="vehicleNumber" placeholder="Vehicle Number" vehicleData={vehicleData} value={values.vehicleNumber} />
                                                                {touched.vehicleNumber && errors.vehicleNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vehicleNumber}</strong> : ''}
                                                            </FormUi.Field>
                                                            <FormUi.Field width="2" />
                                                            <FormUi.Field width="3">
                                                                <label className="labelName mt-2">PO Reference Number</label>
                                                            </FormUi.Field>
                                                            <FormUi.Field width="3">
                                                                <Fieldmik name="poReferenceNo" placeholder="Reference Number" />
                                                                {touched.poReferenceNo && errors.poReferenceNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.poReferenceNo}</strong> : ''}
                                                            </FormUi.Field>
                                                        </FormUi.Group>
                                                    </Container> */}
                                                    <AddProduct billmode={true} />
                                                </>
                                                :
                                                <ActivePurchaseOrder
                                                    refreshedOrder={handleOrderRefresh}
                                                    masterState={masterState}
                                                    vendorStateId={vendorStateId}
                                                    updatePurchaseOrder={updatePurchaseOrder}
                                                    viewmode={true}
                                                    handlePaginationChangeAPI={handlePaginationChange}
                                                    currentPageNoProp={currentPageNoProp}
                                                    totalPagesPresentProp={totalPagesPresentProp}
                                                    handleSearchString={handleSearchString}
                                                    searchTextProps={searchText}
                                                />
                                            }

                                        </div>
                                    </Segment>

                            }
                            <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit' className='margin-bottom-70 mt-4'>Submit</Button></center>
                        </>
                    )}
                </Formik>
            </div>
        </React.Fragment>
    )
}


const mapStatetoProps = state => ({
    vendorPurchaseOrderData: state.getPurchaseOrderReducer.purchaseOrder.data,
    vendorPurchaseOrderLoading: state.getPurchaseOrderReducer.isLoading,
    billData: state.getBillsReducer.bills.data,
    billLoading: state.getBillsReducer.isLoading
})

export default connect(mapStatetoProps, { createBill, getVendorPurchaseOrder, updatePurchaseOrder, getBills })(ViewBill)


